<!-- Panel Header Component -->
<div class="d-flex justify-content-between align-items-center mb-4">
  <h4 class="mb-0">
    <i class="fa {{icon}} me-2 text-primary"></i>
    {{title}}
  </h4>
  <div *ngIf="!editMode; else editModeTemplate">
    <button class="btn btn-primary btn-sm" (click)="toggleEditMode()">
      <i class="fa fa-edit me-1"></i>
      {{editButtonText}}
    </button>
  </div>
  <ng-template #editModeTemplate>
    <div class="btn-group">
      <button class="btn btn-success btn-sm" (click)="onSave()">
        <i class="fa fa-save me-1"></i>
        {{saveButtonText}}
      </button>
      <button class="btn btn-outline-secondary btn-sm" (click)="onCancel()">
        <i class="fa fa-times me-1"></i>
        Cancel
      </button>
    </div>
  </ng-template>
</div>